export const MAX_DECLARED_VALUE_ALLOWED = 3000
export const MAX_REFUND_AMOUND_ALLOWED = 1000
export const MAX_INSURANCE_VALUE_ALLOWED = 2000
